import { Button } from "react-bootstrap";

const VehiclesHeader = ({ searchTerm, onSearchChange, total, onAddVehicle }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Vehicles ({total})</h4>
      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search vehicles"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button type="button" onClick={onAddVehicle}>
          + Add Vehicle
        </Button>
      </div>
    </div>
  );
};

export default VehiclesHeader;
